/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS, List } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { selectProduct } from '../../reports/store/PositionBook.store';
import { putError } from '@/store/error.store';
import { getCurrencyValue } from '@/component/blogic/deals/expenses/ExpensesUtils.jsx';
import { navTo, replaceNavTo } from '../../../../util/util.jsx';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { loadFinTab } from './finTab.store';
import { calcTransportBLCountByAllLinks } from '../expenses/ExpensesUtils';
import { Currency } from '../../../../consts/currency';
const storeDeal = (state, data, dealType) =>
  state.merge(fromJS(data)).setIn(['dealType'], dealType)
    .set('dealLoadedTime', new Date().getTime());

const clearDeal = () => Map();

const storeAudit = (state, data, dealType, id) =>
  state.setIn(['audit', dealType, id], fromJS(data));

const clearAudit = (state) => state.set('audit', new Map());

const changeTransportLinkField = (state, linkId, field, value) => {
  const linkIdx = state.get('links', new List()).findIndex(l => l.get('id') == linkId);
  if (linkIdx < 0) {
    return state;
  }
  let newState = state.setIn(['links', linkIdx, field], value);
  if (field == 'billLandingQuantity' && newState.get('isFreightLS')) {
    const totalBL = calcTransportBLCountByAllLinks(newState);
    const ptFreight = totalBL ? newState.get('freightLSAmount', 0) / totalBL : 0;
    newState = newState.set('freightAmount', ptFreight);
  }
  return newState;
};

const deleteDealLinkInList = (state, linksName, productIdx, linkId) =>
  state.setIn(['products', productIdx, linksName],
    state.getIn(['products', productIdx, linksName], new List())
      .filter(l => l.get('id') != linkId));

const dealAddEvent = (state, event) =>
  state.set('calendarEvents', state.get('calendarEvents', List()).push(fromJS(event)));

const dealEditEvent = (state, oldEvent, newEvent) => {
  const idx = state.get('calendarEvents', List()).findIndex(e => e == oldEvent);
  return state.setIn(['calendarEvents', idx], fromJS(newEvent));
};

const dealDeleteEvent = (state, event) => {
  const idx = state.get('calendarEvents', List()).findIndex(e => e == event);
  return state.deleteIn(['calendarEvents', idx]);
};

export function unlinkTransportFromLinks(products, dealType, transportId) {
  if (!products) {
    return products;
  }
  return products.map((product) => {
    let linksList = product.get(`${dealType}Link`);
    if (linksList) {
      linksList = linksList.map(link => (link.get('transport') == transportId ?
        link.delete('transport') : link));
      return product.set(`${dealType}Link`, linksList);
    }
    return product;
  });
}

const unlinkTransportsOnDelete = (state, id, dealType) => {
  if (!state.get('products')) {
    return state;
  }
  let newState = state;
  if (dealType == 'transport') {
    if (newState.getIn(['products', 0, 'purchaseLink'])) {
      newState = newState.set('products',
        unlinkTransportFromLinks(newState.get('products'), 'purchase', id));
    }
    if (newState.getIn(['products', 0, 'saleLink'])) {
      newState = newState.set('products',
        unlinkTransportFromLinks(newState.get('products'), 'sale', id));
    }
  }
  return newState;
};

const updateFields = (state, map = new Map()) =>
  state.merge(map);

// Expenses
const updateDealExpenseStore = (state, productIdx, expenseIdx, expense) =>
  state.setIn(['products', productIdx, 'expenses', expenseIdx], fromJS(expense));

const addDealExpenseStore = (state, productIdx, expense) =>
  state.setIn(['products', productIdx, 'expenses'],
    state.getIn(['products', productIdx, 'expenses'], new List()).push(fromJS(expense)));

const addDealExpensesStore = (state, productIdx, expenses) =>
  state.setIn(['products', productIdx, 'expenses'],
    state.getIn(['products', productIdx, 'expenses'], new List())
      .concat(expenses.get ? expenses : fromJS(expenses)));

const removeDealExpenseStore = (state, productIdx, expenseIdx, keepIfHasEstimated) => {
  if (keepIfHasEstimated) {
    const expense = state.getIn(['products', productIdx, 'expenses', expenseIdx]);
    if (!expense) {
      return state;
    }
    if (expense.get('estimate')) {
      return state.deleteIn(['products', productIdx, 'expenses', expenseIdx, 'actual'])
        .deleteIn(['products', productIdx, 'expenses', expenseIdx, 'paymentExpense']);
    }
  }
  return state.deleteIn(['products', productIdx, 'expenses', expenseIdx]);
};

const updateTransportExpenseStore = (state, expenseIdx, expense) =>
  state.setIn(['expenses', expenseIdx], fromJS(expense));

const addTransportExpenseStore = (state, expense) => state.set('expenses',
  state.get('expenses', new List()).push(fromJS(expense)));

const addTransportExpensesStore = (state, expenses) => state.set('expenses',
  state.get('expenses', new List()).concat(expenses.get ? expenses : fromJS(expenses)));

const removeTransportExpenseStore = (state, expenseIdx, keepIfHasEstimated) => {
  if (keepIfHasEstimated) {
    const expense = state.getIn(['expenses', expenseIdx]);
    if (expense.get('estimate')) {
      return state.deleteIn(['expenses', expenseIdx, 'actual'])
        .deleteIn(['expenses', expenseIdx, 'paymentExpense']);
    }
  }
  return state.deleteIn(['expenses', expenseIdx]);
};
// Payments
const preparePaymentPath = (productIdx, paymentIdxs) => {
  const path = [];
  if (productIdx >= 0) {
    path.push('products');
    path.push(productIdx);
  }
  if (paymentIdxs && paymentIdxs.length > 0) {
    paymentIdxs.forEach((idx) => {
      path.push('payments');
      path.push(idx);
    });
  }
  return path;
};

const preparePaymentPathToPayments = (productIdx, paymentIdxs) => {
  const path = preparePaymentPath(productIdx, paymentIdxs);
  path.push('payments');
  return path;
};

const preparePaymentPathForDirty = (productIdx, paymentIdxs) => {
  const path = [];
  if (productIdx >= 0) {
    path.push('products');
    path.push(productIdx);
  }
  if (paymentIdxs && paymentIdxs.length == 0) {
    path.push('payments');
    path.push(0);
    path.push('isDirty');
  }
  if (paymentIdxs && paymentIdxs.length > 0) {
    path.push('payments');
    path.push(paymentIdxs[0]);
    path.push('isDirty');
  }
  return path;
};

const paymentsLoaded = (state, payments, storeVar) =>
  state.set(storeVar || 'payments', fromJS(payments).map((p, idx) => p.set('paymentIdx', idx)));

const saveDealPaymentStore = (state, productIdx, paymentIdx, payment) => {
  const path = preparePaymentPath(productIdx, [paymentIdx]);
  const pathToDirty = preparePaymentPathForDirty(productIdx, [paymentIdx]);
  return state
    .setIn(path, fromJS(payment))
    .setIn(pathToDirty, false);
};

const updateDealPaymentStore = (state, productIdx, paymentIdxs, payment) => {
  const path = preparePaymentPath(productIdx, paymentIdxs);
  const pathToDirty = preparePaymentPathForDirty(productIdx, paymentIdxs);
  return state
    .setIn(path, fromJS(payment).set('paymentIdx', state.getIn([...path, 'paymentIdx'])))
    .setIn(pathToDirty, true);
};

const addDealPaymentStore = (state, productIdx, paymentIdxs, payment, insertAt0) => {
  const pathToPayments = preparePaymentPathToPayments(productIdx, paymentIdxs);
  const pathToDirty = preparePaymentPathForDirty(productIdx, paymentIdxs);
  return state
    .setIn(pathToDirty, true)
    .setIn(pathToPayments, insertAt0 ?
      state.getIn(pathToPayments, new List()).insert(0, fromJS(payment)) :
      state.getIn(pathToPayments, new List())
        .push(fromJS(payment)).map((p, idx) => p.set('paymentIdx', idx)));
};

const removeDealPaymentStore = (state, productIdx, paymentIdxs, paymentIdx) => {
  let newState = state;
  if (paymentIdxs && paymentIdxs.length > 0) {
    const pathToDirty = preparePaymentPathForDirty(productIdx, paymentIdxs);
    newState = newState.setIn(pathToDirty, true);
  }
  const pathToPayments = preparePaymentPathToPayments(productIdx, paymentIdxs);
  return newState
    .setIn(pathToPayments,
      newState.getIn(pathToPayments, new List()).filter((val, idx) => idx != paymentIdx)
        .map((p, idx) => p.set('paymentIdx', idx)));
};

// Products
const newProduct = state =>
  state.set('products', state.get('products', new List()).push(new Map()));

const changeProductData = (state, idx, newProductData) =>
  state.setIn(['products', idx], state.getIn(['products', idx]).merge(newProductData));

const changeProductField = (state, idx, field, value) =>
  state.setIn(['products', idx, field], value);

const changeProductFields = (state, idx, map = new Map()) =>
  state.setIn(['products', idx],
    state.getIn(['products', idx], new Map()).merge(map),
  );

const unlinkTransportFromLink = (state, link) => state.set('products',
  state.get('products').map((product) => {
    const purchaseLinkIdx = product.get('purchaseLink', new List()).indexOf(link);
    if (purchaseLinkIdx > -1) {
      return product.deleteIn(['purchaseLink', purchaseLinkIdx, 'transport'])
        .deleteIn(['purchaseLink', purchaseLinkIdx, 'billLandingQuantity'])
        .deleteIn(['purchaseLink', purchaseLinkIdx, 'freightAmount']);
    }
    const saleLinkIdx = product.get('saleLink', new List()).indexOf(link);
    if (saleLinkIdx > -1) {
      return product.deleteIn(['saleLink', saleLinkIdx, 'transport'])
        .deleteIn(['saleLink', saleLinkIdx, 'billLandingQuantity'])
        .deleteIn(['saleLink', saleLinkIdx, 'freightAmount']);
    }
    return product;
  }),
);

const linkTransport = (state, productIdx, linkIdx, transportId, freightAmount) => {
  const product = state.getIn(['products', productIdx]);
  let link = product.get('purchaseLink', new List()).get(linkIdx);
  if (link) {
    return state.setIn(['products', productIdx, 'purchaseLink', linkIdx, 'transport'], transportId)
      .setIn(['products', productIdx, 'purchaseLink', linkIdx, 'freightAmount'], freightAmount);
  }
  link = product.get('saleLink').get(linkIdx);
  if (link) {
    return state.setIn(['products', productIdx, 'saleLink', linkIdx, 'transport'], transportId)
      .setIn(['products', productIdx, 'saleLink', linkIdx, 'freightAmount'], freightAmount);
  }
  return state;
};

const updateLinkInProduct = (state, dealFrom, productIdx, linkIdx, link) =>
  state.setIn(['products', productIdx, `${dealFrom}Link`, linkIdx], fromJS(link));

const deleteLinkFromProduct = (state, productIdx, linkIdx) => {
  const product = state.getIn(['products', productIdx]);
  let link = product.get('purchaseLink', new List()).get(linkIdx);
  if (link) {
    return state.setIn(['products', productIdx, 'purchaseLink', linkIdx, 'hidden'], true);
  }
  link = product.get('saleLink', new List()).get(linkIdx);
  if (link) {
    return state.setIn(['products', productIdx, 'saleLink', linkIdx, 'hidden'], true);
  }
  return state;
};
const changeProductMode = (state, productIdx, mode) => {
  if (state.getIn(['products', productIdx])) {
    return state.setIn(['products', productIdx, 'displayMode'], mode);
  }
  return mode;
};

const searchDuplicatesResult = (state, data) => state.set('duplicates', fromJS(data));

const clearDuplicates = state => state.delete('duplicates');

const clearBulkPaymentsDuplicatesReducer = state => state.delete('bulkPaymentsDuplicates');

const searchBulkPaymentsDuplicatesResult = (state, data) =>
  state.set('bulkPaymentsDuplicates', fromJS(data));

const calculateSum = (items, field, currencyField, currencyRates) =>
  items.map((i) => {
    if (i.get('loadingPort') || i.get('dischargePort')) {
      return getCurrencyValue(i, field, currencyField, currencyRates);
    }
    return 0.0;
  }).reduce((sum, v) => sum + v, 0);


const setLaytimeTotal = (state) => {
  const li = state.get('laytimeItems');
  const transportDebit = calculateSum(li.get('loadingItems')
    .concat(li.get('dischargeItems')), 'demurrageAmount',
  'demurrageCurrency', 'demurrageCurrencyRates');
  const transportCredit = calculateSum(li.get('loadingItems')
    .concat(li.get('dischargeItems')), 'dispatchAmount',
  'dispatchCurrency', 'dispatchCurrencyRates');
  const linkedDebit = calculateSum(li.get('suppliersItems')
    .concat(li.get('buyersItems')), 'dispatchAmount',
  'dispatchCurrency', 'dispatchCurrencyRates');
  const linkedCredit = calculateSum(li.get('suppliersItems')
    .concat(li.get('buyersItems')), 'demurrageAmount',
  'demurrageCurrency', 'demurrageCurrencyRates');
  const result = transportDebit - transportCredit + linkedDebit - linkedCredit;
  return state.set('totalDemurrage', transportDebit - linkedCredit)
    .set('totalDispatch', -transportCredit + linkedDebit)
    .set('laytimeTotal', fromJS({
      actual: Math.abs(result),
      actualCurrency: 'USD',
      estimateCurrency: 'USD',
      summType: 'LS',
      isDebit: (result >= 0),
    }));
};

const initLaytime = (state, laytimeItems) =>
  setLaytimeTotal(state.set('laytimeItems', fromJS(laytimeItems)));

const updateLaytime = (state, itemType, idx, obj) => {
  if (state.getIn(['laytimeItems', itemType, idx])) {
    return setLaytimeTotal(setLaytimeTotal(state.setIn(['laytimeItems', itemType, idx],
      fromJS({ ...state.getIn(['laytimeItems', itemType, idx]).toJS(), ...obj }))));
  }
  return state;
};

const updateLaytimeVesselName = (state, itemType, idx, vesselName) => {
  if (state.getIn(['laytimeItems', itemType, idx, 'vesselName']) != undefined) {
    return state.setIn(['laytimeItems', itemType, idx, 'vesselName'], vesselName);
  }
  return state;
};

const addLaytime = (state, itemType, obj) => setLaytimeTotal(state
  .setIn(['laytimeItems', itemType],
    state.getIn(['laytimeItems', itemType]).push(fromJS(obj))));

const deleteLaytimeForTransport = (state, deletedIndex) =>
  setLaytimeTotal(state.setIn(['laytimeItems', 'loadingItems'],
    state.deleteIn(['laytimeItems', 'loadingItems', deletedIndex])
      .getIn(['laytimeItems', 'loadingItems']).map((i, idx) => i.set('nameIndex', idx)))
    .setIn(['laytimeItems', 'dischargeItems'],
      state.deleteIn(['laytimeItems', 'dischargeItems', deletedIndex])
        .getIn(['laytimeItems', 'dischargeItems']).map((i, idx) => i.set('nameIndex', idx))));

const updateField = (state, dealType, field, value, deleteIdx) => {
  let newState = state;
  if (dealType == 'transport') {
    if (deleteIdx != undefined) {
      newState = deleteLaytimeForTransport(newState, deleteIdx);
    }
    if (Array.isArray(value)) {
      value.forEach((v, idx) => {
        newState = updateLaytimeVesselName(
          updateLaytimeVesselName(newState, 'loadingItems', idx, v.vesselName),
          'dischargeItems', idx, v.vesselName);
      });
    }
  }
  return newState.set(field, fromJS(value));
};

const updateProductField = (state, dealType, productIdx, field, value) => {
  if (dealType != 'transport') {
    if (field instanceof Array) {
      return state.setIn(['products', productIdx].concat(field), value);
    }
    return state.setIn(['products', productIdx, field], value);
  }
  return state;
};

const portFieldAltered = (state, portType, id) => state.set(portType, id);

const vesselNameAltered = (state, name) => state.set('vesselName', name);

const wsPaymentCreated = (state, data) =>
  (state.get('dealType') ? state :
    state.set('payments', state.get('payments', new List()).splice(0, 0, fromJS(data))
      .map((p, idx) => p.set('paymentIdx', idx))));

const wsPaymentUpdated = (state, data) => {
  const isTransport = state.get('dealType', '') == 'transport';
  if (isTransport) {
    const paymentIdx = state.get('payments', new List()).findIndex(p => p.get('id') == data.id);
    if (paymentIdx >= 0) {
      return state.setIn(['payments', paymentIdx], fromJS(data)
        .set('paymentIdx', state.getIn(['payments', paymentIdx, 'paymentIdx'])));
    }
    return state;
  }
  let products = state.get('products', new List());
  let payments = state.get('payments', new List());
  if (products.size) {
    products = products.map(product => {
      payments = product.get('payments', new List());
      const paymentIdx = payments.findIndex(p => p.get('id') == data.id);
      if (paymentIdx >= 0) {
        payments = payments.set(paymentIdx, fromJS(data));
        return product.set('payments', payments);
      }
      return product;
    });
    return state.set('products', products);
  } else if (payments.size) {
    const paymentIdx = payments.findIndex(p => p.get('id') == data.id);
    if (paymentIdx >= 0) {
      return state.setIn(['payments', paymentIdx], fromJS(data)
        .set('paymentIdx', state.getIn(['payments', paymentIdx, 'paymentIdx'])));
    }
    return state;
  }
  return state;
};

const setNewPayment = (state, payment) => {
  if (payment == null) {
    return state.delete('payment');
  }
  return state.set('payment', state.get('payment', new Map()).merge(payment));
};
const setPaymentApproved = (paymentHost, isTransport, id, prodIdx) => {
  let paymentToApprove;
  let path;
  paymentHost.get('payments', new List()).forEach((payment, paymentIdx) => {
    if (!paymentToApprove) {
      if (payment.get('id') == id) {
        paymentToApprove = payment;
        path = isTransport ? ['payments', paymentIdx] :
          ['products', prodIdx, 'payments', paymentIdx];
      } else {
        payment.get('payments', new List()).forEach((subPayment, subPaymentIdx) => {
          if (subPayment.get('id') == id) {
            paymentToApprove = subPayment;
            path = isTransport ? ['payments', paymentIdx, 'payments', subPaymentIdx] :
              ['products', prodIdx, 'payments', paymentIdx, 'payments', subPaymentIdx];
          }
        });
      }
    }
  });
  return { paymentToApprove, path };
};

const paymentApproved = (state, data) => {
  let result;
  const isTransport = state.get('dealType', '') == 'transport';
  if (isTransport) {
    result = setPaymentApproved(state, isTransport, data.id);
  } else {
    state.get('products', new List()).forEach((product, prodIdx) => {
      result = setPaymentApproved(product, isTransport, data.id, prodIdx);
    });
  }

  if (result && result.path && result.paymentToApprove) {
    return state.setIn(result.path,
      result.paymentToApprove.set('approveComment', (data.note || ''))
        .set('topManagerApproveState', data.state))
      .delete('topApproverLinkExpireTime');
  }
  return state;
};

const updateTransshipmentExpense = (state, dealType, productIdx, transshipmentExpense) => {
  if (!transshipmentExpense || !transshipmentExpense.get('name')) {
    return state;
  }
  if (dealType == 'transport') {
    return state;
  }

  const nodeToUsd = node => {
    const newNode = { ...node };
    newNode.costActual = getCurrencyValue(node, 'costActual', 'currency', 'currencyRates');
    newNode.costEstimated = getCurrencyValue(node, 'costEstimated', 'currency', 'currencyRates');
    return newNode;
  };

  const addCurrenciesToNode = (route) => route
    .set('nodes', route.get('nodes')
      .map(node => node.set('currencyRates', route.get('currencyRates'))));

  const sumRoutes = (a, b) => ({
    costActual: (a.costActual || 0) + (b.costActual || 0) * (b.quantity || 0),
    costEstimated: (a.costEstimated || 0) + (b.costEstimated || 0) * (b.quantity || 0),
    quantity: (a.quantity || 0) + (b.quantity || 0),
  });

  const createExpense = (avgEstimated, avgActual, rates) => new Map({
    expensesType: transshipmentExpense.get('id'),
    expensesTypeName: transshipmentExpense.get('name'),
    isDebit: true,
    summType: 'LS',
    actual: Number(avgActual.toFixed(2)),
    estimate: Number(avgEstimated.toFixed(2)),
    estimateCurrency: Currency.DOLLAR,
    estimateCurrencyRates: rates,
    paymentExpense: true,
  });
  const flattenNodes = (nodes, currencyRates) => nodes.reduce((sum, node) => {
    const rates = node.currencyRates || currencyRates;
    sum.push(nodeToUsd(node, rates));
    if (node.elements && node.elements.length) {
      // eslint-disable-next-line
      sum = sum.concat(flattenNodes(node.elements, rates));
    }
    return sum;
  }, []);
  const rootNodes = state.getIn(['products', productIdx, 'multiNodalRoutes'], new List())
    .map(addCurrenciesToNode)
    .flatMap(route => route.get('nodes'))
    .toJS();

  const allNodes = flattenNodes(rootNodes).filter(route => route.quantity);

  const totalValues = allNodes.reduce((sum, elem) => sumRoutes(sum, elem),
    { costActual: 0, costEstimated: 0, quantity: 0 });
  const newExpense = createExpense(totalValues.costEstimated,
    totalValues.costActual,
    state.getIn(['products', productIdx, 'multiNodalRoutes', 0, 'currencyRates'], new List()));
  let expenses = state.getIn(['products', productIdx, 'expenses'], new List());
  const expenseIdx = expenses
    .findIndex(elem => elem.get('expensesTypeName') == transshipmentExpense.get('name'));

  if (totalValues.costEstimated || totalValues.costActual) {
    if (expenseIdx >= 0) {
      expenses = expenses
        .set(expenseIdx, newExpense.set('id', expenses.getIn([expenseIdx, 'id'])));
    } else {
      expenses = expenses.push(newExpense);
    }
  } else {
    if (expenseIdx >= 0) {
      expenses = expenses.remove(expenseIdx);
    }
  }
  return state.setIn(['products', productIdx, 'expenses'], expenses);
};

const applyToEachNode = (nodes, func) => nodes.map(node => {
  let modified = func(node);
  modified = modified.set('elements', applyToEachNode(modified.get('elements', new List()), func));
  return modified;
});

const deleteMultiNodalLink = (state, productIdx, linkIdx) => {
  const path = ['products', productIdx, 'multiNodalRoutes'];
  return state.setIn(path, state.getIn(path).map(route =>
    route.set('nodes', applyToEachNode(route.get('nodes', new List()), node => {
      if (node.get('linkIdx')) {
        return node.set('linkIdx', (node.get('linkIdx', new List()) || new List())
          .filter(l => l !== linkIdx));
      }
      return node;
    }))));
};


const updateShrinkageExpenseState = (state, product, productIdx, shrinkageExpense) => {
  if (!shrinkageExpense || !shrinkageExpense.get('name')) {
    return state;
  }
  let expenses = state.getIn(['products', productIdx, 'expenses'], new List());
  const expenseIdx = expenses
    .findIndex(elem => elem.get('expensesTypeName') == shrinkageExpense.get('name'));
  let currentExpense;
  if (expenseIdx >= 0) {
    currentExpense = state.getIn(['products', productIdx, 'expenses', expenseIdx]);
  }
  if (!product.get('fixedPrice')) {
    if (currentExpense) {
      currentExpense = currentExpense.set('actual', 0).set('paymentExpense', false);
      return state.setIn(['products', productIdx, 'expenses', expenseIdx], currentExpense);
    }
    return state;
  }
  const shrinkage = product.get('shrinkageIsPercentage') ?
    (Number(product.get('quantityMin', 0)) + product.get('quantityMax', 0)) / 2
    * product.get('shrinkagePercent') / 100
    : product.get('shrinkage');
  const actual = product.get('priceValue', 0) * shrinkage;
  if (currentExpense) {
    currentExpense = currentExpense
      .set('actual', actual)
      .set('summType', 'LS')
      .set('estimateCurrency', product.get('priceCurrency', Currency.DOLLAR))
      .set('estimateCurrencyRates', product.get('priceCurrencyRates'))
      .set('paymentExpense', !!actual)
      .set('isDebit', true);
    return state.setIn(['products', productIdx, 'expenses', expenseIdx], currentExpense);
  }
  const newExpense = new Map({
    expensesType: shrinkageExpense.get('id'),
    expensesTypeName: shrinkageExpense.get('name'),
    isDebit: true,
    summType: 'LS',
    actual: Number(actual.toFixed(2)),
    estimateCurrency: product.get('priceCurrency', Currency.DOLLAR),
    estimateCurrencyRates: product.get('priceCurrencyRates'),
    paymentExpense: !!actual,
  });
  expenses = expenses.push(newExpense);
  return state.setIn(['products', productIdx, 'expenses'], expenses);
};

export const dealEditReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'DEAL_LOADED':
      return storeDeal(state, action.data, action.dealType);
    case 'UPDATE_DEAL_FROM_COPY':
      return storeDeal(state, action.data, action.dealType);
    case 'EDIT_DEAL_FIELD':
      return updateField(state, action.dealType, action.field, action.value, action.idx);
    case 'EDIT_DEAL_PRODUCT_FIELD':
      return updateProductField(state, action.dealType, action.productIdx,
        action.field, action.value);
    case 'EDIT_DEAL_MULTINODAL_FIELD': {
      const newState = updateProductField(state, action.dealType, action.productIdx,
        action.field, action.value);
      return updateTransshipmentExpense(
        newState, action.dealType, action.productIdx, action.transshipmentExpense);
    }
    case 'LINK_CREATED': {
      const createdLinkRoutesPath = ['products', action.productIdx, 'multiNodalRoutes'];
      const createLinksCount = action.links.size;
      const multiNodalLinks = action.allLinks.filter(l => l.get('fromMultiNodal'));
      if (multiNodalLinks.size) {
        return state.setIn(createdLinkRoutesPath, state.getIn(createdLinkRoutesPath,
          new List()).map(route =>
          route.set('nodes', applyToEachNode(route.get('nodes', new List()), node => {
            if (node.get('linkCreation')) {
              const newLinksIdx = [];
              for (let i = multiNodalLinks.size - createLinksCount; i < multiNodalLinks.size; i++) {
                newLinksIdx.push(i);
              }
              return node.set('linkIdx', (node.get('linkIdx', new List()) || new List())
                .concat(fromJS(newLinksIdx))).delete('linkCreation');
            }
            return node;
          }))));
      }
      return state;
    }
    case 'LINK_CANCELED': {
      const routesPath = ['products', action.productIdx, 'multiNodalRoutes'];
      return state.setIn(routesPath, state.getIn(routesPath, new List()).map(route =>
        route.set('nodes', applyToEachNode(route.get('nodes', new List()),
          node => node.delete('linkCreation')))
      ));
    }
    case 'EDIT_DEAL_MULTINODAL_ADD_ROUTE_SUB_ELEMENT': {
      const path = ['products', action.productIdx, 'multiNodalRoutes', action.routeIdx,
        'nodes', ...action.fieldPath];
      return state.setIn(path, state.getIn(path, new List()).push(fromJS({})));
    }
    case 'EDIT_DEAL_FIELDS':
      return updateFields(state, action.map);
    case 'TRANSPORT_EDIT_LINK':
      return changeTransportLinkField(state, action.linkId, action.field, action.value);
    case 'DEAL_DELETE_LINK':
      return deleteDealLinkInList(state, action.linksName, action.productIdx, action.linkId);
    case 'CLEAR_DEAL':
      return clearDeal(state);

    case 'AUDIT_LOADED':
      return storeAudit(state, action.data, action.dealType, action.id);
    case 'CLEAR_AUDIT':
      return clearAudit(state);

    case 'ADD_DEAL_EVENT':
      return dealAddEvent(state, action.event);
    case 'EDIT_DEAL_EVENT':
      return dealEditEvent(state, action.oldEvent, action.newEvent);
    case 'DELETE_DEAL_EVENT':
      return dealDeleteEvent(state, action.event);
    case 'WS_RECEIVED_DEAL_DELETED':
      return unlinkTransportsOnDelete(state, action.id, action.dealType);
    case 'DEAL_DUPLICATES_SEARCH_COMPLETED':
      return searchDuplicatesResult(state, action.data);
    case 'DEAL_DUPLICATES_CLEAR':
      return clearDuplicates(state);
    case 'BULK_PAYMENTS_DUPLICATES_CLEAR':
      return clearBulkPaymentsDuplicatesReducer(state);
    case 'BULK_PAYMENTS_DUPLICATES_FOUND':
      return searchBulkPaymentsDuplicatesResult(state, action.data);
    // Deal expenses
    case 'UPDATE_DEAL_EXPENSE':
      return updateDealExpenseStore(
        state,
        action.productIdx,
        action.expenseIdx,
        action.expense);
    case 'ADD_DEAL_EXPENSE':
      return addDealExpenseStore(
        state,
        action.productIdx,
        action.expense);
    case 'ADD_DEAL_EXPENSES':
      return addDealExpensesStore(
        state,
        action.productIdx,
        action.expenses);
    case 'REMOVE_DEAL_EXPENSE':
      return removeDealExpenseStore(
        state,
        action.productIdx,
        action.expenseIdx,
        action.keepIfHasEstimated);
    case 'SET_DEAL_EXPENSES':
      return state.setIn(['products', action.productIdx, 'expenses'],
        fromJS(action.expenses));
    // Transport expenses
    case 'SET_TRANSPORT_EXPENSES':
      return state.set('expenses', fromJS(action.expenses));
    case 'UPDATE_TRANSPORT_EXPENSE':
      return updateTransportExpenseStore(
        state,
        action.expenseIdx,
        action.expense);
    case 'ADD_TRANSPORT_EXPENSE':
      return addTransportExpenseStore(
        state,
        action.expense);
    case 'ADD_TRANSPORT_EXPENSES':
      return addTransportExpensesStore(
        state,
        action.expenses);
    case 'REMOVE_TRANSPORT_EXPENSE':
      return removeTransportExpenseStore(
        state,
        action.expenseIdx,
        action.keepIfHasEstimated);

    // Payments
    case 'PAYMENTS_LOADED':
    case 'DETACHED_PAYMENTS_LOADED':
      return paymentsLoaded(
        state,
        action.payments,
        action.storeVar);
    case 'PAYMENT_SAVING_SUCCESS':
      return saveDealPaymentStore(
        state,
        action.productIdx,
        action.paymentIdx,
        action.payment);
    case 'UPDATE_DEAL_PAYMENT':
      return updateDealPaymentStore(
        state,
        action.productIdx,
        action.paymentIdxs,
        action.payment);
    case 'ADD_DEAL_PAYMENT':
      return addDealPaymentStore(
        state,
        action.productIdx,
        action.paymentIdxs,
        action.payment,
        action.insertAt0);
    case 'REMOVE_DEAL_PAYMENT':
      return removeDealPaymentStore(
        state,
        action.productIdx,
        action.paymentIdxs,
        action.paymentIdx);

    case 'NEW_PRODUCT_ADDED':
      return newProduct(state);
    case 'PRODUCT_ALTERED':
      return changeProductData(
        state,
        action.idx,
        action.newProductData);
    case 'PRODUCT_FIELD_ALTERED':
      return changeProductField(
        state,
        action.idx,
        action.field,
        action.value);
    case 'PRODUCT_FIELDS_ALTERED':
      return changeProductFields(state, action.idx, action.map);
    case 'TRANSPORT_UNLINK':
      return unlinkTransportFromLink(
        state,
        action.link);
    case 'LINK_TRANSPORT':
      return linkTransport(
        state,
        action.productIdx,
        action.linkIdx,
        action.transportId,
        action.freightAmount);
    case 'UPDATE_LINK':
      return updateLinkInProduct(
        state,
        action.dealFrom,
        action.productIdx,
        action.linkIdx,
        action.link);
    case 'DELETE_LINK':
      return deleteLinkFromProduct(
        deleteMultiNodalLink(state, action.productIdx, action.linkIdx),
        action.productIdx,
        action.linkIdx);
    case 'LAYTIME_INIT':
      return initLaytime(state, action.laytimeItems);
    case 'LAYTIME_UPDATE':
      return updateLaytime(state, action.itemType, action.idx, action.obj);
    case 'LAYTIME_ADD':
      return addLaytime(state, action.itemType, action.obj);
    case 'DEAL_PORT_FIELD_ALTERED':
      return portFieldAltered(state, action.portType, action.id);
    case 'ALTER_VESSEL_NAME':
      return vesselNameAltered(state, action.name);
    case 'PRODUCT_MODE_SWITCH':
      return changeProductMode(state, action.productIdx, action.mode);
    case 'LOADING_DETACHED_PAYMENTS':
    case 'LOADING_PAYMENTS':
      return state.set('payments', new List());
    case 'NEW_DETACHED_PAYMENT':
      return setNewPayment(state, action.payment);
    case 'UPDATE_DETACHED_PAYMENT':
      return state.setIn(['payment', action.prop], action.value);
    case 'WS_PAYMENT_CREATED':
      return wsPaymentCreated(state, action.data);
    case 'WS_PAYMENT_UPDATED':
      return wsPaymentUpdated(state, action.data);
    case 'DETACHED_PAYMENT_MODAL':
      return state.set('showModal', action.state);
    case 'UPDATE_FOB_NETBACK' :
      return state.setIn(['products', action.productIdx, 'userFobNetback'], action.value);
    case 'WS_PAYMENT_TOP_APPROVED':
      return paymentApproved(state, action.data);
    case 'COUNTERPARTY_OUSTANDINGS_LOADED':
      return state.set('counterpartyOutstandings', fromJS(action.data));
    case 'ADD_MULTI_NODAL_TABLE':
      return state.setIn(['products', action.productIdx, 'multiNodalRoutes'],
        state.getIn(['products', action.productIdx, 'multiNodalRoutes'], new List())
          .push(new Map({ currencyRates: action.rates, nodes: fromJS([{
            creationDate: new Date().getTime(),
            quantity: 0,
            currency: 'USD',
          }]) }))
      );
    case 'DELETE_MULTINODAL_TABLE': {
      const newState = state.setIn(['products', action.productIdx, 'multiNodalRoutes'],
        state.getIn(['products', action.productIdx, 'multiNodalRoutes'], new List())
          .delete(action.routeIdx)
      );
      return updateTransshipmentExpense(
        newState, action.dealType, action.productIdx, action.transshipmentExpense);
    }
    case 'UPDATE_SHRINKAGE_EXPENSE':
      return updateShrinkageExpenseState(
        state, action.product, action.productIdx, action.shrinkageExpense);
    default:
      return state;
  }
};
export const updateShrinkageExpense = (dispatch, product, productIdx, shrinkageExpense) =>
  dispatch({ type: 'UPDATE_SHRINKAGE_EXPENSE', dispatch, product, productIdx, shrinkageExpense });
export const unlinkTransport = (dispatch, link) =>
  dispatch({ type: 'TRANSPORT_UNLINK', link });
export const addTransportToLink = (dispatch, productIdx, linkIdx, transportId, freightAmount) =>
  dispatch({ type: 'LINK_TRANSPORT', productIdx, linkIdx, transportId, freightAmount });
export const saveLinkChanges = (dispatch, dealFrom, productIdx, linkIdx, link) =>
  dispatch({ type: 'UPDATE_LINK', dealFrom, productIdx, linkIdx, link });
export const deleteLink = (dispatch, productIdx, linkIdx) =>
  dispatch({ type: 'DELETE_LINK', productIdx, linkIdx });
export const changeTransportLink = (dispatch, linkId, field, value) => {
  dispatch({ type: 'TRANSPORT_EDIT_LINK', linkId, field, value });
};
export const clearLink = dispatch =>
  dispatch({ type: 'LINK_CLEARED' });

export const addNewProduct = dispatch =>
  dispatch({ type: 'NEW_PRODUCT_ADDED' });
export const alterProduct = (dispatch, idx, newProductData) =>
  dispatch({ type: 'PRODUCT_ALTERED', idx, newProductData });
export const alterProductField = (dispatch, idx, field, value) =>
  dispatch({ type: 'PRODUCT_FIELD_ALTERED', idx, field, value });
export const alterProductFields = (dispatch, idx, map) =>
  dispatch({ type: 'PRODUCT_FIELDS_ALTERED', idx, map });
export const addDealEvent = (dispatch, event) =>
  dispatch({ type: 'ADD_DEAL_EVENT', event });
export const deleteDealEvent = (dispatch, event) =>
  dispatch({ type: 'DELETE_DEAL_EVENT', event });
export const editDealEvent = (dispatch, oldEvent, newEvent) =>
  dispatch({ type: 'EDIT_DEAL_EVENT', oldEvent, newEvent });


export const updateDealExpense = (dispatch, productIdx, expenseIdx, expense) => {
  dispatch({ type: 'UPDATE_DEAL_EXPENSE', productIdx, expenseIdx, expense });
};
export const addDealExpense = (dispatch, productIdx, expense) => {
  dispatch({ type: 'ADD_DEAL_EXPENSE', productIdx, expense });
};
export const addDealExpenses = (dispatch, productIdx, expenses) => {
  dispatch({ type: 'ADD_DEAL_EXPENSES', productIdx, expenses });
};
export const removeDealExpense = (dispatch, productIdx, expenseIdx, keepIfHasEstimated) => {
  dispatch({ type: 'REMOVE_DEAL_EXPENSE', productIdx, expenseIdx, keepIfHasEstimated });
};
export const setDealExpenses = (dispatch, productIdx, expenses = new List()) => {
  dispatch({ type: 'SET_DEAL_EXPENSES', productIdx, expenses });
};
export const seTransportExpenses = (dispatch, expenses = new List()) => {
  dispatch({ type: 'SET_TRANSPORT_EXPENSES', expenses });
};

export const updateTransportExpense = (dispatch, expenseIdx, expense) => {
  dispatch({ type: 'UPDATE_TRANSPORT_EXPENSE', expenseIdx, expense });
};
export const addTransportExpense = (dispatch, expense) => {
  dispatch({ type: 'ADD_TRANSPORT_EXPENSE', expense });
};
export const addTransportExpenses = (dispatch, expenses) => {
  dispatch({ type: 'ADD_TRANSPORT_EXPENSES', expenses });
};
export const removeTransportExpense = (dispatch, expenseIdx, keepIfHasEstimated) => {
  dispatch({ type: 'REMOVE_TRANSPORT_EXPENSE', expenseIdx, keepIfHasEstimated });
};
export const updateFobNetback = (dispatch, productIdx, value) => {
  dispatch({ type: 'UPDATE_FOB_NETBACK', productIdx, value });
};

export const loadDealPayments = (dispatch) => {
  dispatch({ type: 'LOADING_PAYMENTS' });
  markStoreLoading(dispatch, 'FIN_PAYMENTS');
  return RestAPI.get('/deals/payments/api')
    .then(
      (payments) => {
        dispatch({ type: 'PAYMENTS_LOADED', payments });
        markStoreLoaded(dispatch, 'FIN_PAYMENTS');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'PAYMENTS_LOADING_FAILED' });
        markStoreLoaded(dispatch, 'FIN_PAYMENTS');
        return true;
      },
    );
};

export const loadDetachedPayments = (dispatch, storeVar) => {
  dispatch({ type: 'LOADING_DETACHED_PAYMENTS' });
  markStoreLoading(dispatch, 'COMMON_PAYMENTS');
  return RestAPI.get('/deals/payments/api/detached/all')
    .then(
      (payments) => {
        dispatch({ type: 'DETACHED_PAYMENTS_LOADED', payments, storeVar });
        markStoreLoaded(dispatch, 'COMMON_PAYMENTS');
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'DETACHED_PAYMENTS_LOADING_FAILED' });
        markStoreLoaded(dispatch, 'COMMON_PAYMENTS');
        return true;
      },
    );
};

export const loadCounterpartyOutstandings = (dispatch) => {
  dispatch({ type: 'LOADING_COUNTERPARTY_OUTSTANDINGS' });
  return RestAPI.get('/dict/counterparty/outstandings/map')
    .then(
      (cos) => {
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_LOADED', data: cos });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_LOADING_FAILED' });
        return true;
      },
    );
};

export const deleteCounterpartyOutstanding = (dispatch, id) => {
  dispatch({ type: 'DELETE_COUNTERPARTY_OUTSTANDINGS' });
  return RestAPI.delete(`/dict/counterparty/outstandings/${id}`)
    .then(
      (result) => {
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_DELETED', result });
        loadCounterpartyOutstandings(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_DELETE_FAILED' });
        return true;
      },
    );
};

export const saveCounterpartyOutstanding = (dispatch, cos) => {
  dispatch({ type: 'SAVING_COUNTERPARTY_OUTSTANDINGS' });
  return RestAPI.post('/dict/counterparty/outstandings/save', cos)
    .then(
      (result) => {
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_SAVED', result });
        loadCounterpartyOutstandings(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'COUNTERPARTY_OUSTANDINGS_SAVING_FAILED' });
        return true;
      },
    );
};

export const tryToSaveDealPayment = (dispatch, payment, productIdx, paymentIdxs,
  addNew, isCommonSubpayment) => {
  dispatch({ type: 'PAYMENT_SAVE_BEGUN', data: payment });
  let path = '';
  let paymentJS = payment;
  if (payment.get) {
    paymentJS = payment.toJS();
  }
  if (paymentJS.id || paymentJS.id === 0) {
    path = `${paymentJS.id}`;
  } else if (paymentJS.parent || paymentJS.parent === 0) {
    path = `addto/${paymentJS.parent}`;
  } else {
    return undefined;
  }
  return RestAPI.post(`/deals/payments/api/${path}`, paymentJS, 'application/json')
    .then(
      (data) => {
        dispatch({ type: 'PAYMENT_SAVING_SUCCESS', payment: data });
        if (addNew && !isCommonSubpayment) {
          dispatch({ type: 'ADD_DEAL_PAYMENT', productIdx, paymentIdxs, payment: data });
        } else if (!addNew) {
          dispatch({ type: 'UPDATE_DEAL_PAYMENT', productIdx, paymentIdxs, payment });
        }
        return true;
      },
    ).catch(
      (data) => {
        if (data.status === 403 || data.status === 401) {
          return true;
        }
        putError(dispatch, data);
        dispatch({ type: 'PAYMENT_SAVE_ATTEMPT_FAILED' });
        return false;
      },
    );
};
export const updateDealPayment = (dispatch, productIdx, paymentIdxs, payment) => {
  dispatch({ type: 'UPDATE_DEAL_PAYMENT', productIdx, paymentIdxs, payment });
};
export const addDealPayment = (dispatch, productIdx, paymentIdxs, payment, insertAt0 = false) => {
  dispatch({ type: 'ADD_DEAL_PAYMENT', productIdx, paymentIdxs, payment, insertAt0 });
};
export const removeDealPayment = (dispatch, serverSide, id,
  productIdx, paymentIdxs, paymentIdx) => {
  if (serverSide && id != null && id != undefined) {
    dispatch({ type: 'DELETING_PAYMENT_FROM_SERVER' });
    return RestAPI.delete(`/deals/payments/api/${id}`)
      .then(
        () => {
          dispatch({ type: 'REMOVE_DEAL_PAYMENT', productIdx, paymentIdxs, paymentIdx });
          return true;
        },
      ).catch(
        (data) => {
          if (data.status === 403 || data.status === 401) {
            return true;
          }
          putError(dispatch, data);
          dispatch({ type: 'PAYMENT_DELETE_ATTEMPT_FAILED' });
          return false;
        },
      );
  // eslint-disable-next-line
  } else {
    dispatch({ type: 'REMOVE_DEAL_PAYMENT', productIdx, paymentIdxs, paymentIdx });
    return true;
  }
};

let reloadAfterSave = false;

export const loadDeal = (dispatch, type, id) => {
  reloadAfterSave = false;
  dispatch({ type: 'LOADING_DEAL' });
  return RestAPI.get(`/deals/${type}/api/${id}`)
    .then(
      (data) => {
        dispatch({ type: 'DEAL_LOADED', data, dealType: type });
        if (type == 'purchase' && id) {
          loadFinTab(dispatch, id);
        }
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'DEAL_LOADING_FAILED' });
        return true;
      },
    );
};
const dealSaveFailed = (dispatch, data, type) => {
  if (data.status === 403 || data.status === 401) {
    return true;
  }
  if (data.exception == 'ru.sggr.starter.deal.transport.EmptyProductsTransportException') {
    // eslint-disable-next-line
    putError(dispatch, {['Unable to save transport']: data.message, exception: false});
  } else if (data.exception == 'ru.sggr.starter.deal.payments.PaymentWithBlankDueDateException') {
    putError(dispatch, { 'Unable to save deal': data.message, exception: false });
  } else {
    putError(dispatch, data);
  }
  dispatch({ type });
  return false;
};

export const tryToSaveDeal = (dispatch, deal, type, callGoToList, dontReload) => {
  dispatch({ type: 'DEAL_SAVE_BEGUN', data: deal });
  return RestAPI.post(`/deals/${type}/api/`, deal, false, true)
    .then(
      (data) => {
        dispatch({ type: 'DEAL_SAVING_SUCCESS', dealType: type });
        if (callGoToList) {
          navTo(`/deals/${type}`); // we need to cut [0-9]* from link
        } else {
          if (!dontReload) {
            replaceNavTo(`/deals/${type}/${data.id}`);
          }
        }
        return true;
      },
    ).catch(
      (data) => dealSaveFailed(dispatch, data, 'DEAL_SAVE_ATTEMPT_FAILED')
    );
};

export const tryToUpdateDeal = (dispatch,
  deal,
  dealType,
  id,
  callGoToList,
  dontReload) => {
  dispatch({ type: 'DEAL_UPDATE_BEGUN', data: deal });
  reloadAfterSave = true;
  return RestAPI.post(`/deals/${dealType}/api/${id}`, deal, false, true)
    .then(
      () => {
        dispatch({ type: 'DEAL_UPDATE_SUCCESS', dealType });
        if (callGoToList) {
          navTo(`/deals/${dealType}`);
        } else {
          if (!dontReload && reloadAfterSave) {
            loadDeal(dispatch, dealType, id);
          }
        }
        return true;
      },
    ).catch(
      (data) => dealSaveFailed(dispatch, data, 'DEAL_UPDATE_ATTEMPT_FAILED')
    );
};
export const tryToDeleteDeal = (dispatch, type, id) => {
  dispatch({ type: 'DELETING_DEAL' });
  return RestAPI.delete(`/deals/${type}/api/${id}`)
    .catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'DEAL_DELETE_FAILED' });
        return true;
      },
    );
};

export const updateDealMarketPrice = (dispatch, type, dealId, productId, marketPrice) => {
  dispatch({ type: 'UPDATE_DEAL_MARKET_PRICE' });
  return RestAPI.post(`/deals/${type}/api/${dealId}/updatemp`, {
    id: dealId,
    productId,
    marketPrice,
  })
    .then(
      () => {
        dispatch({ type: 'UPDATE_DEAL_MARKET_PRICE_COMPLETED', dealId, productId, marketPrice });
        selectProduct(dispatch, null, null);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'UPDATE_DEAL_MARKET_PRICE_FAILED' });
        return true;
      },
    );
};

export const clearDealStore = (dispatch, dealType) => {
  dispatch({ type: 'CLEAR_DEAL', dealType });
};
export const clearDealEditType = (dispatch) => {
  dispatch({ type: 'CLEAR_DEAL_EDIT_TYPE' });
};
export const updateDealField = (dispatch, dealType, field, value, idx) => {
  dispatch({ type: 'EDIT_DEAL_FIELD', dealType, field, value, idx });
};
export const updateDealProductField = (dispatch, dealType, productIdx, field, value) => {
  dispatch({ type: 'EDIT_DEAL_PRODUCT_FIELD', dealType, productIdx, field, value });
};
export const updateMultiNodalFieldField = (dispatch, dealType, productIdx,
  field, value, transshipmentExpense) => {
  dispatch({ type: 'EDIT_DEAL_MULTINODAL_FIELD', dealType, productIdx,
    field, value, transshipmentExpense });
};
export const addRouteSubElement = (dispatch, productIdx, routeIdx, fieldPath) => {
  dispatch({ type: 'EDIT_DEAL_MULTINODAL_ADD_ROUTE_SUB_ELEMENT', productIdx, routeIdx, fieldPath });
};
export const updateDealFields = (dispatch, map) => {
  dispatch({ type: 'EDIT_DEAL_FIELDS', map });
};
export const addMultiNodalTable = (dispatch, productIdx, rates) => {
  dispatch({ type: 'ADD_MULTI_NODAL_TABLE', productIdx, rates });
};
export const deleteMultiNodalRoute = (dispatch, dealType, productIdx, routeIdx,
  transshipmentExpense) => {
  dispatch({ type: 'DELETE_MULTINODAL_TABLE', productIdx, routeIdx,
    dealType, transshipmentExpense });
};
export const loadAuditList = (dispatch, type, id) => {
  dispatch({ type: 'LOADING_AUDIT' });
  return RestAPI.get(`/audit/api/${type}/diffs/${id}`)
    .then(
      (data) => {
        dispatch({ type: 'AUDIT_LOADED', data, dealType: type, id });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'AUDIT_LOADING_FAILED' });
        return true;
      },
    );
};
export const clearAuditStore = (dispatch) => {
  dispatch({ type: 'CLEAR_AUDIT' });
};

export const selectProductMode = (dispatch, productIdx, mode) => {
  dispatch({ type: 'PRODUCT_MODE_SWITCH', productIdx, mode });
};


export const searchDealDuplicates = (dispatch, type, deal, okCallback) => {
  dispatch({ type: 'DEAL_DUPLICATES_SEARCH_BEGIN', data: deal });
  return RestAPI.post(`/search/api/${type}/duplicates`, deal, false, true)
    .then(
      (data) => {
        if (Object.keys(data).length) {
          dispatch({ type: 'DEAL_DUPLICATES_SEARCH_COMPLETED', data });
        } else {
          okCallback();
        }
        return true;
      },
    ).catch(
      (data) => {
        if (data.status === 403 || data.status === 401) {
          return true;
        }
        putError(dispatch, data);
        dispatch({ type: 'DEAL_DUPLICATES_SEARCH_FAILED' });
        return false;
      },
    );
};

export const searchBulkPaymentsDuplicates = (dispatch, type, deal, okCallback) => {
  dispatch({ type: 'BULK_PAYMENTS_DUPLICATES_SEARCH_BEGIN', data: deal });
  return RestAPI.post(`/search/api/${type}/bulkpayments/duplicates`, deal, false, true)
    .then(
      (data) => {
        if (Object.keys(data).length) {
          dispatch({ type: 'BULK_PAYMENTS_DUPLICATES_FOUND', data });
        } else {
          okCallback();
        }
        return true;
      },
    ).catch(
      (data) => {
        if (data.status === 403 || data.status === 401) {
          return true;
        }
        putError(dispatch, data);
        dispatch({ type: 'BULK_PAYMENTS_DUPLICATES_SEARCH_FAILED' });
        return false;
      },
    );
};


export const updateDealFromCopy = (dispatch, deal, dealType) =>
  dispatch({ type: 'UPDATE_DEAL_FROM_COPY', data: deal.toJS(), dealType });

export const clearDealDuplicates = (dispatch) => {
  dispatch({ type: 'DEAL_DUPLICATES_CLEAR' });
};

export const clearBulkPaymentsDuplicates = (dispatch) => {
  dispatch({ type: 'BULK_PAYMENTS_DUPLICATES_CLEAR' });
};

export const initLaytimeAction = (dispatch, laytimeItems) => {
  dispatch({ type: 'LAYTIME_INIT', laytimeItems });
};

export const updateLaytimeAction = (dispatch, itemType, idx, obj) => {
  dispatch({ type: 'LAYTIME_UPDATE', itemType, idx, obj });
};

export const addLaytimeAction = (dispatch, itemType, obj) => {
  dispatch({ type: 'LAYTIME_ADD', itemType, obj });
};

export const alterPortField = (dispatch, portType, id) => {
  dispatch({ type: 'DEAL_PORT_FIELD_ALTERED', portType, id });
};

export const alterVesselname = (dispatch, name) => {
  dispatch({ type: 'ALTER_VESSEL_NAME', name });
};

export const detachedPaymentModal = (dispatch, state) => {
  dispatch({ type: 'DETACHED_PAYMENT_MODAL', state });
};

export const setDetachedPayment = (dispatch, payment) => {
  dispatch({ type: 'NEW_DETACHED_PAYMENT', payment });
};

export const updateDetachedPayment = (dispatch, prop, value) => {
  dispatch({ type: 'UPDATE_DETACHED_PAYMENT', prop, value });
};

export const tryToSaveDetachedPayment = (dispatch, deal, callback) => {
  dispatch({ type: 'DETACHED_PAYMENT_BEGIN', data: deal });
  return RestAPI.post('/deals/payments/api/add/new', deal, false, true)
    .then(
      (data) => {
        dispatch({ type: 'DETACHED_PAYMENT_SAVED', data });
        callback();
        return true;
      },
    ).catch(
      (data) => {
        if (data.status === 403 || data.status === 401) {
          return true;
        }
        putError(dispatch, data);
        dispatch({ type: 'DETACHED_PAYMENT_SAVE_FAILED' });
        return false;
      },
    );
};

export const tryToUpdateDetachedPayment = (dispatch, id, deal, callback) => {
  dispatch({ type: 'DETACHED_PAYMENT_UPDATE_BEGIN', data: deal });
  return RestAPI.post(`/deals/payments/api/detached/${id}`, deal, false, true)
    .then(
      (data) => {
        dispatch({ type: 'DETACHED_PAYMENT_UPDATED', data });
        callback();
        return true;
      },
    ).catch(
      (data) => {
        if (data.status === 403 || data.status === 401) {
          return true;
        }
        putError(dispatch, data);
        dispatch({ type: 'DETACHED_PAYMENT_UPDATE_FAILED' });
        return false;
      },
    );
};
